@if (value) {
  <img [src]="value">
}
